(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;
    let location = window.location.href;
    let collectionHandle = location.split("/collections/")[1];
    if (
      url &&
      url.toLowerCase() ===
        "https://m6gr3ndvb9vprvw9bs1ca9qb.fast.sparq.ai/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);

      let sorting = body.sort;
sorting.unshift('-in_stock')
      const str = body.filter;
      const match = str.match(/collectionHandles\s*=\s*"([^"]+)"/);
      const collectionHandle = match ? match[1] : null;

      if (
        sorting.length == 0 &&
        !location.includes("/search") &&
        !location.includes("/all")
      ) {
        if (collectionHandle)
          body.sort.push(
            `sortOrderFor_${collectionHandle
              .replaceAll("-", "_")
              .toLowerCase()}`
          );
      }

      if (
        body.sort.length > 1 &&
        !location.includes("/search") &&
        !location.includes("/all")
      ) {
        if (collectionHandle)
          sorting = sorting.filter(
            (x) =>
              x !==
              `sortOrderFor_${collectionHandle
                .replaceAll("-", "_")
                .toLowerCase()}`
          );
        body.sort = sorting;
      }

      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search({ page: 1, restrictByCollection: false });
};

window.addEventListener("load", (event) => {
  let element = document.querySelector(".sq-container.sq-app");
  let loader = document.querySelector(".sq-sy-loader");

  if (!element && loader) {
    loader.style.display = "block";
  } else {
    if (loader) loader.style.display = "none";
  }
});

window.sq.initSearches = (store) => {
  const inStockFilter = document.getElementById("sq-filter-in-stock");
  const outStockFilter = document.getElementById("sq-filter-out-stock");

  store.filter = store.filter.replace("variants.inventory_quantity > 0", "");
  store.filter = store.filter.replace("variants.inventory_quantity = 0", "");

  if (inStockFilter.checked && !outStockFilter.checked) {
    store.filter = store.filter
      ? `${store.filter} AND variants.inventory_quantity > 0`
      : "variants.inventory_quantity > 0";
    history.replaceState(null, null, "?instock=true");
  } else if (!inStockFilter.checked && outStockFilter.checked) {
    store.filter = store.filter
      ? `${store.filter} AND variants.inventory_quantity = 0`
      : "variants.inventory_quantity = 0";
    history.replaceState(null, null, "?instock=false");
  } else {
    history.replaceState(null, null, window.location.pathname);
  }

  store.search();
};

function toggleHeight() {
  const rteElement = document.querySelector(
    ".sq-app .collection__description .rte"
  );
  const toggleTextElement = document.querySelector(
    ".expandable-content__toggle-text"
  );
  const toggleIconElement = document.querySelector(
    "span.expandable-content__toggle-icon:before"
  );

  if (rteElement.style.height === "100%") {
    rteElement.style.height = "90%";
    toggleTextElement.textContent =
      toggleTextElement.getAttribute("data-view-more");
    toggleIconElement.style.display = "block";
  } else {
    rteElement.style.height = "100%";
    toggleTextElement.textContent =
      toggleTextElement.getAttribute("data-view-less");
    toggleIconElement.style.display = "none !important";
  }
}

function toggleFilter() {
  let x = document.querySelector(".sq-sidebar.filter");
  x.classList.toggle("opening");
}

function removeClass() {
  let z = document.querySelector(".sq-sidebar.filter");
  z.classList.remove("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-sidebar.filter");
  y.classList.remove("opening");
}

window.sq.sort = () => {
  const valuePickerButton = document.querySelector(
    ".sq-sort.value-picker-button"
  );
  const sortSelector = document.querySelector("#sort-by-selector");

  const isExpanded = valuePickerButton.getAttribute("aria-expanded") === "true";
  valuePickerButton.setAttribute("aria-expanded", !isExpanded);
  sortSelector.setAttribute("aria-hidden", isExpanded);
};

window.sq.perPage = () => {
  const valuePickerButton = document.querySelector(
    "button.sq-per-page.value-picker-button"
  );
  const sortSelector = document.querySelector("#display-by-selector");

  const isExpanded = valuePickerButton.getAttribute("aria-expanded") === "true";
  valuePickerButton.setAttribute("aria-expanded", !isExpanded);
  sortSelector.setAttribute("aria-hidden", isExpanded);
};

window.sq.changeView = () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  if (gridButton) {
    gridButton.addEventListener("click", () => {
      productList?.classList.remove("list-view");
      dataGrid.style.display = "flex";
      gridButton?.classList.add("is-selected");
      dataGrid?.classList.remove("sq-list-view");
      listButton?.classList.remove("is-selected");
      window.sq.custom = { isList: false };
    });
  }
  if (listButton) {
    listButton.addEventListener("click", () => {
      productList?.classList.add("list-view");
      dataGrid?.classList.add("sq-list-view");
      gridButton?.classList.remove("is-selected");
      listButton?.classList.add("is-selected");
      window.sq.custom = { isList: true };
    });
  }
};

window.addEventListener("load", () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  if (gridButton) {
    gridButton.addEventListener("click", () => {
      productList?.classList.remove("list-view");
      dataGrid.style.display = "flex";
      gridButton?.classList.add("is-selected");
      dataGrid?.classList.remove("sq-list-view");
      listButton?.classList.remove("is-selected");
      window.sq.custom = { isList: false };
    });
  }

  if (listButton) {
    listButton.addEventListener("click", () => {
      productList?.classList.add("list-view");
      dataGrid?.classList.add("sq-list-view");
      gridButton?.classList.remove("is-selected");
      listButton?.classList.add("is-selected");
      window.sq.custom = { isList: true };
    });
  }
});

function appendClass() {
  const appliedFilters = document.querySelectorAll(
    ".sq-filter-item.sq-block.sq-active"
  );
  const clearBtn = document.querySelector(".clear-all");

  if (appliedFilters.length >= 1) {
    clearBtn?.classList.add("added");
  } else {
    clearBtn?.classList.remove("added");
  }
}

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (
      url &&
      url.toLowerCase() ===
        "https://sii2vlcr6p45uhey8gn61qyq.fast.sparq.ai/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);
      body.facetCount = 1000;
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

window.sq.priceChange = (store) => {
  setTimeout(() => {
    document.querySelectorAll(".sq-results-item").forEach((e) => {
      let sqPrice = e.querySelector(".sq-price");
      let sqComparePrice = e.querySelector(".sq-compare-price");
      let sqDiscountPrice = e.querySelector(".ymq_item_price");
      sqPrice.innerText = sqPrice.innerText.replace(".", ",");
      if (sqComparePrice)
        sqComparePrice.innerText = sqComparePrice.innerText.replace(".", ",");
      if (sqDiscountPrice)
        sqDiscountPrice.innerText = sqDiscountPrice.innerText.replace(".", ",");
    });
  }, 200);

  return true;
};

setTimeout(() => {
  document
    .querySelector("form.search-bar")
    .addEventListener("submit", function (event) {
      
      event.preventDefault(); // This stops the form from submitting
      let url = new URL(location.origin+'/search');
       const inputValue = document.querySelector('[name="q"]').value;
      // Update the 'q' parameter value
      const selectedValue = document.getElementById('search-product-type').value;
      const transformedValue = selectedValue.toLowerCase().replace(/\s+/g, '_');
      url.searchParams.set("q", inputValue);
      if(transformedValue) url.searchParams.set('system_producttype', transformedValue);
      location.href = url.toString();
    });
}, 500);
